import { useCallback, useMemo } from 'react';

import { useErpSurveyResponseDetailLazyQuery } from 'core/graphql';

import { ISurveyResponseDetail, parseResponseDetail } from './surveyModel';

interface ISurveyResponseDetailHook {
  load: (responseId: string) => void;
  detail: ISurveyResponseDetail | null;
  loading: boolean;
  error?: string;
}

/**
 * Spec 0011 — one student's named answers, fetched lazily when the operator
 * opens the drawer on the results page. The JSONString `value` of every
 * answer is decoded here (transform layer) so components receive plain
 * bool / int / str / int[] values and never touch `JSON.parse`.
 */
export const useSurveyResponseDetail = (): ISurveyResponseDetailHook => {
  const [run, { data, loading, error }] = useErpSurveyResponseDetailLazyQuery({
    fetchPolicy: 'cache-and-network',
  });

  const load = useCallback(
    (responseId: string) => {
      run({ variables: { responseId } });
    },
    [run],
  );

  const detail = useMemo(
    () =>
      data?.surveyResponseDetail
        ? parseResponseDetail(data.surveyResponseDetail)
        : null,
    [data?.surveyResponseDetail],
  );

  return { load, detail, loading, error: error?.message };
};
